import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCaretDown } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { retrieveData, storeData } from "../LocalConnection/LocalConnection";
import "./CSS/Dashboad.css";
const Breadcrumb = ({ title, onDateSelection }) => {
  const location = useLocation();
  const [showDateInputs, setShowDateInputs] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const [showDate, SetShowDate] = useState(false);
  const dropdownRef = useRef(null);
  const periodSelected = retrieveData("period");
  const [selectedPeriod, setSelectedPeriod] = useState(
    parseInt(retrieveData("period"))
  );
  // console.log(parseInt(periodSelected) + "=" + selectedPeriod);
  // Handler to manage the dropdown selection

  useEffect(() => {
    if (periodSelected === "0") {
      storeData("period", 6);
    } else {
      return;
    }
  }, [periodSelected]);

  const handleDropdownChange = (selectedValue) => {
    try {
      storeData("period", selectedValue);
      setSelectedPeriod(selectedValue);

      if (selectedValue === 5) {
        setShowDateInputs(true);
      } else {
        handleSubmit(selectedValue);
        setShowDateInputs(false);
      }

      SetShowDate(false);
    } catch (error) {
      console.error("An error occurred in handleDropdownChange:", error);
    }
  };
  const handleSHowdate = () => {
    SetShowDate(!showDate);
  };

  const handleSearch = () => {
    console.log("Searching for period:", selectedPeriod);
    if (
      selectedPeriod === 5 &&
      startDate &&
      startDate !== "" &&
      endDate &&
      endDate !== ""
    ) {
      handleSubmit(selectedPeriod);
    }
  };

  const handleSubmit = (selectedPerioddata) => {
    // Passing data back to the parent component
    onDateSelection(
      startDate.toISOString().split("T")[0],
      endDate.toISOString().split("T")[0],
      selectedPerioddata
    );
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        SetShowDate(false);
      }
    };
    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  return (
    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-20">
      <div className="titleDash">
        {" "}
        <h6 className="fw-semibold mb-0">{title}</h6>
      </div>
      {onDateSelection !== null && (
        <div className="DropDownandsearchabr">
          <div className="dropdown position-relative " ref={dropdownRef}>
            <div className="SelectTimeFram" onClick={handleSHowdate}>
              <button type="button">
                {selectedPeriod
                  ? selectedPeriod === 1
                    ? "This Week"
                    : selectedPeriod === 2
                    ? "This Month"
                    : selectedPeriod === 3
                    ? "Last 6 Months"
                    : selectedPeriod === 4
                    ? "This Year"
                    : selectedPeriod === 5
                    ? "Custom"
                    : "Select Time Period"
                    ? "All"
                    : selectedPeriod === 6
                  : "Select Time Period"}
              </button>
              <FaCaretDown
                style={{
                  transform: showDate ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s ease",
                }}
              />
            </div>

            {showDate && (
              <div className="dataDropDownptions">
                <button onClick={() => handleDropdownChange(1)}>
                  This Week
                </button>
                <button onClick={() => handleDropdownChange(2)}>
                  This Month
                </button>
                <button onClick={() => handleDropdownChange(3)}>
                  Last 6 Months
                </button>
                <button onClick={() => handleDropdownChange(4)}>
                  This Year
                </button>
                <button onClick={() => handleDropdownChange(5)}>Custom</button>
                <button onClick={() => handleDropdownChange(6)}>
                  All
                </button>
              </div>
            )}
          </div>

          {showDateInputs && (
            <>
              <div className="d-flex gap-2 ">
                <div className="mb-2 startDatePicker">
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="Start Date"
                    className="form-control date-input"
                  />
                </div>
                <div className="  ">
                  <DatePicker
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="End Date"
                    className="form-control date-input"
                  />
                </div>
              </div>
              <button
                className="btn btn-primary SearchdataDash"
                onClick={handleSearch}
              >
                Search
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default Breadcrumb;
